<template>
  <section
    class="p-4 pb-0"
    :class="{
      'pl-8': isReply,
      'pr-0': isReply,
      'sm:pl-[3.75rem]': isReply,
      'mb-4': !isReply,
    }"
  >
    <div>
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2 sm:gap-3">
          <img
            :src="comment.avatar || defaultAvatar"
            :onerror="'this.src=' + defaultAvatar"
            :alt="comment.nickname"
            class="rounded-full"
            :class="{
              'h-6': isReply,
              'w-6': isReply,
              'sm:h-10': isReply,
              'sm:w-10': isReply,
              'h-8': !isReply,
              'w-8': !isReply,
              'sm:h-12': !isReply,
              'sm:w-12': !isReply,
            }"
          />
          <div class="text-sm text-[#666]">{{ comment.nickname }}</div>
        </div>
        <open-app-btn :extinfo="extinfo">
          <component :is="'style'">
            .comment-like { display: flex; align-items: center; gap:
            {{ rootRem * 0.5 }}px; font-size: {{ rootRem * 0.875 }}px; color: #333;}
            .comment-like-img { width: {{ rootRem * 0.875 }}px; height:
            {{ rootRem * 0.875 }}px; }
          </component>
          <div class="comment-like">
            <img
              src="@/assets/images/comment/comment-item-like.png"
              class="comment-like-img"
            />
            <span>{{ comment.likeCount }}</span>
          </div>
        </open-app-btn>
      </div>
      <div
        class="mt-2 whitespace-pre-wrap pl-10 text-justify text-sm leading-relaxed text-[#333] sm:pl-[3.75rem]"
      >
        {{ comment.content }}
        <img
          v-if="comment.image_s || comment.image"
          class="lazy mt-2 object-cover"
          :src="VITE_DEFAULT_IMAGE_1_1"
          :data-src="comment.image_s || comment.image"
          :class="{ 'h-24 w-24': isReply, 'h-36 w-36': !isReply }"
          @click="toPreviewImage"
        />
        <div class="mt-2 flex items-center gap-4">
          <div class="text-xs text-[#999]">
            {{ getLatesMinutes(comment.publishTime || '') }}
          </div>
          <open-app-btn :extinfo="extinfo">
            <component :is="'style'">
              .comment-reply { color: #333; font-size:{{ rootRem * 0.75 }}px; }
            </component>
            <div>回复</div>
          </open-app-btn>
        </div>
        <template v-if="isReply && replyCount > 1">
          <open-app-btn :extinfo="extinfo">
            <component :is="'style'">
              .comment-reply-count-box {display: flex;} .comment-reply-count { color:
              #333; font-size: {{ rootRem * 0.875 }}px; background: #f0f0f0; height:
              {{ rootRem * 1.625 }}px; border-radius: 99px; line-height:
              {{ rootRem * 1.625 }}px; padding: 0 {{ rootRem }}px; display: flex;
              margin-top: {{ rootRem * 0.5 }}px; align-items: center; justify-content:
              center; gap: 5px; width: auto; } .comment-reply-arrow { width:
              {{ rootRem * 0.652 }}px; }
            </component>
            <div class="comment-reply-count-box">
              <div class="comment-reply-count">
                展开{{ replyCount }}条回复
                <img
                  class="comment-reply-arrow"
                  src="@/assets/images/comment/comment-replay-arrow.png"
                />
              </div>
            </div>
          </open-app-btn>
        </template>
      </div>
    </div>
    <template v-if="!isReply">
      <comment-item
        v-for="reply in (comment as Dynamic.DynamicCommentContent).godReplies"
        :key="reply.uuid"
        :comment="reply"
        is-reply
        :reply-count="(comment as Dynamic.DynamicCommentContent).replyCount"
      ></comment-item>
    </template>
  </section>
</template>

<script setup lang="ts">
import { getLatesMinutes, previewImage } from '@/utils';
import { useRem } from '@/utils/hooks';

const { VITE_DEFAULT_AVATAR: defaultAvatar, VITE_DEFAULT_IMAGE_1_1 } = import.meta.env;
const props = withDefaults(
  defineProps<{
    comment: Dynamic.DynamicCommentContent | Dynamic.DynamicCommentReply;
    isReply?: boolean;
    replyCount?: number;
  }>(),
  { isReply: false, replyCount: 0 },
);
const extinfo = inject<Ref<string>>('extinfo', ref(''));
const rootRem = useRem();

const toPreviewImage = () => {
  previewImage([props.comment.image || props.comment.image_s]);
};
</script>
